/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * MyYoast
 * The MyYoast Api
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ProvisionerProductDto
} from '../models';

import { customFetch } from '../../customFetch';
import type { ErrorType } from '../../customFetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListProvisionerProductsUrl = () => {




  return `/api/provisioning/products`
}

/**
 * Returns every product code the authenticated provisioner may pass when provisioning, with the name of the product it provisions and the product groups that product includes.
 * @summary List the provisioner's product codes.
 */
export const listProvisionerProducts = async ( options?: Parameters<typeof customFetch>[1]): Promise<ProvisionerProductDto[]> => {

  return customFetch<ProvisionerProductDto[]>(getListProvisionerProductsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProvisionerProductsQueryKey = () => {
    return [
    `/api/provisioning/products`
    ] as const;
    }


export const getListProvisionerProductsQueryOptions = <TData = Awaited<ReturnType<typeof listProvisionerProducts>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProvisionerProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProvisionerProductsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProvisionerProducts>>> = ({ signal }) => listProvisionerProducts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProvisionerProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProvisionerProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listProvisionerProducts>>>
export type ListProvisionerProductsQueryError = ErrorType<void>


export function useListProvisionerProducts<TData = Awaited<ReturnType<typeof listProvisionerProducts>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProvisionerProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProvisionerProducts>>,
          TError,
          Awaited<ReturnType<typeof listProvisionerProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProvisionerProducts<TData = Awaited<ReturnType<typeof listProvisionerProducts>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProvisionerProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProvisionerProducts>>,
          TError,
          Awaited<ReturnType<typeof listProvisionerProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProvisionerProducts<TData = Awaited<ReturnType<typeof listProvisionerProducts>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProvisionerProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the provisioner's product codes.
 */

export function useListProvisionerProducts<TData = Awaited<ReturnType<typeof listProvisionerProducts>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProvisionerProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProvisionerProductsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListProvisionerProductsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listProvisionerProducts>>, TError = ErrorType<void>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProvisionerProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProvisionerProductsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProvisionerProducts>>> = ({ signal }) => listProvisionerProducts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProvisionerProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProvisionerProductsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listProvisionerProducts>>>
export type ListProvisionerProductsSuspenseQueryError = ErrorType<void>


export function useListProvisionerProductsSuspense<TData = Awaited<ReturnType<typeof listProvisionerProducts>>, TError = ErrorType<void>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProvisionerProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProvisionerProductsSuspense<TData = Awaited<ReturnType<typeof listProvisionerProducts>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProvisionerProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProvisionerProductsSuspense<TData = Awaited<ReturnType<typeof listProvisionerProducts>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProvisionerProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the provisioner's product codes.
 */

export function useListProvisionerProductsSuspense<TData = Awaited<ReturnType<typeof listProvisionerProducts>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProvisionerProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProvisionerProductsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






